'use client';

import { __assign } from '../../_virtual/_tslib.js';

var THRESHOLD_1 = 1;
var THRESHOLD_2 = 6;
var THRESHOLD_3 = 8;
var THRESHOLD_4 = 10;
var STEP_1 = 0.5;
var STEP_2 = 1;
var STEP_3 = 2;
var MINIMUM_NUMERIC_DATA = 6;
/*
 * Get number information
 * Return:
 *   numberLength    Length of number (ex: length of 212 is 3)
 *   powOf10Number   Power of 10 of number by it's length - 1
 *   integer         integer part of number after divided by powOf10Number
 *   decimal         decimal part of number (fixed to 1 number) after divided by powOf10Number
 *
 * */
function getNumberInformation(number) {
    if (number < 10) {
        return [{ integer: number, decimal: 0 }, 1, 1];
    }
    var numberLength = Math.floor(Math.log10(number)) + 1;
    var powOf10Number = Math.pow(10, numberLength - 1);
    var dividedNumber = number / powOf10Number;
    var decimalNumber = dividedNumber.toString().split('.')[1];
    return [
        {
            integer: Math.floor(dividedNumber),
            decimal: decimalNumber ? parseInt(decimalNumber.substring(0, 1)) : 0
        },
        numberLength,
        powOf10Number
    ];
}
/*
 * Get maxNumber and step after converted
 * @param number     Number between 1 to 9
 * @param powOf10    Power of 10 of number
 * @param step       maxNumber will be roundup by number + step * powOf10
 *   ex: 121 will be roundup to 150 and step is 50
 * */
function convertMaxNumber(number, step, powOf10) {
    var convertedStep = step * powOf10;
    if (number > THRESHOLD_2 && number < THRESHOLD_3) {
        /*
         * The number between THRESHOLD_2 and THRESHOLD_3 is 7
         * if number is equal to 7, i don't want it to be 9 and step 2
         * so that, i have to minus it by 1 and it will be 8 and step 2 after converted
         * */
        var convertedNumber = (number - 1) * powOf10 + convertedStep;
        return {
            maxNumber: convertedNumber,
            step: convertedStep
        };
    }
    if (number > THRESHOLD_3) {
        /*
         * Since, i just want number after converted is between 1 to 10
         * so, if the number is greater than 8, i have to roundup number by
         * add it with (10 - number)
         * */
        return {
            maxNumber: (number + (THRESHOLD_4 - number)) * powOf10,
            step: convertedStep
        };
    }
    return {
        maxNumber: number * powOf10 + convertedStep,
        step: convertedStep
    };
}
/*
 * Apply logic to get step and maxNumber corresponding
 * @param number     Max number in chart data
 * */
function getStepAndConvertMaxNumber(number) {
    var maxNumber = number;
    if (maxNumber === 0) {
        maxNumber = MINIMUM_NUMERIC_DATA;
    }
    var _a = getNumberInformation(maxNumber), _b = _a[0], integer = _b.integer, decimal = _b.decimal, numberLength = _a[1], powOf10Number = _a[2];
    if (numberLength === THRESHOLD_1 && integer < THRESHOLD_4) {
        /*
         * This logic is for number between 0 to 10
         * If number is less than 6, step will be 1, otherwise step will be 2
         * and the number will be MINIMUM_NUMERIC_NUMBER, cause i don't want
         * the range in axes will be in 0 to 1 or 0 to number less than 5
         * */
        if (integer <= THRESHOLD_2) {
            return convertMaxNumber(MINIMUM_NUMERIC_DATA, STEP_2, powOf10Number);
        }
        return convertMaxNumber(integer, STEP_3, powOf10Number);
    }
    if (integer === THRESHOLD_1) {
        /*
         * This logic is for number which greater than 10 and integer part is 1
         * Step is 0.5
         * */
        if (decimal < THRESHOLD_2 - 1) {
            return convertMaxNumber(integer, STEP_1, powOf10Number);
        }
        /*
         * If decimal part of number is greater than 5
         * i have to add number's integer part by step 0.5 before convertMaxNumber
         * Example:
         * Number: 151
         *   - integer: 1
         *   - decimal: 5
         * if i don't add integer by step 0.5 so that number after
         * convertMaxNumber(integer, STEP_1, powOf10Number) is 150.
         * This is wrong since 150 is less than 151
         * so that i have to add integer by step 0.5 before convert
         * */
        var convertedNumber = integer + STEP_1;
        return convertMaxNumber(convertedNumber, STEP_1, powOf10Number);
    }
    if (integer > THRESHOLD_1 && integer < THRESHOLD_2) {
        /*
         * This logic is for for number which integer part is between 2 and 6
         * Step is 1
         * */
        return convertMaxNumber(integer, STEP_2, powOf10Number);
    }
    /* Otherwise step is 2 */
    return convertMaxNumber(integer, STEP_3, powOf10Number);
}
function getDataRangeInAxes(chartConfig) {
    var data = chartConfig.data, xField = chartConfig.xField, yField = chartConfig.yField, _a = chartConfig.series, series = _a === void 0 ? '' : _a;
    var convertedData = {};
    var seriesValues = [];
    var numericData = [];
    var xAxis = [];
    var yAxis = [];
    var dataBySeries = {};
    data.map(function (item) {
        var _a;
        numericData.push(item[yField]);
        if (!xAxis.includes(item[xField])) {
            xAxis.push(item[xField]);
        }
        if (!seriesValues.includes(item[series])) {
            seriesValues.push(item[series]);
        }
        convertedData[item[xField]] = series
            ? __assign(__assign({}, convertedData[item[xField]]), (_a = {}, _a[item[series]] = item[yField], _a)) : item[yField];
        if (series) {
            dataBySeries[item[series]] = dataBySeries[item[series]]
                ? dataBySeries[item[series]].concat([item[yField]])
                : [item[yField]];
        }
    });
    var _b = getStepAndConvertMaxNumber(Math.max.apply(Math, numericData)), maxNumber = _b.maxNumber, step = _b.step;
    for (var i = maxNumber; i >= 0; i -= step) {
        yAxis.push(i);
    }
    return {
        xAxis: xAxis,
        yAxis: yAxis,
        series: seriesValues,
        data: convertedData,
        step: step,
        dataBySeries: dataBySeries
    };
}
var data = {
    getDataRangeInAxes: getDataRangeInAxes
};

export { data as default };
//# sourceMappingURL=data.js.map
